import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=6145ca90&scoped=true"
import script from "./configDialog.vue?vue&type=script&lang=js"
export * from "./configDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145ca90",
  null
  
)

export default component.exports